/* eslint-disable import/no-cycle */
import { connect } from 'react-redux';
import { cleanLetters, setFilter } from 'redux-core/letters/actions';

const mapDispatchToProps = { cleanLetters, setFilter };

export default connect(undefined, mapDispatchToProps);
